
export default function FieldWeex({label, children}){

  return (
      <div className={"field"}>
        <div className={"label"}>{label}</div>
        <div className={"value"}>{children}</div>
      </div>
  );
};

